import { inject } from 'inversify-props';
import { IStorage } from '../../services';
import { SearchRequest } from '../common/SearchRequest';
import { Company } from '../industry/Company';

export class TechnologySearchRequest extends SearchRequest {

	@inject('IStorage')
	public storage: IStorage;

	public deckIds: string[] = [];
	public deckVariationIds: string[] = [];
	public companyIds: string[] = [];
	public companies: Company[] = [];

	constructor(init?: any) {
		super(init);
		if (!init) { return; }
		if (init.companyIds) {
			if (Array.isArray(init.companyIds)) {
				this.companyIds = init.companyIds;
			} else {
				this.companyIds = init.companyIds.split(',');
			}
		}
		if (init.deckIds) {
			if (Array.isArray(init.deckIds)) {
				this.deckIds = init.deckIds;
			} else {
				this.deckIds = init.deckIds.split(',');
			}
		}
		if (init.deckVariationIds) {
			if (Array.isArray(init.deckVariationIds)) {
				this.deckVariationIds = init.deckVariationIds;
			} else {
				this.deckVariationIds = init.deckVariationIds.split(',');
			}
		}

		// INSTEAD OF GETTING THESE VALUES FROM THE DATABASE, TRY AND GET THEM FROM LOCAL STORAGE
		const json = this.storage.retrieve('technology-filter');
		if (!json) { return; }

		const prevFilter = JSON.parse(json) as TechnologySearchRequest;
		if (!prevFilter) { return; }

		// RESTORE COMPANIES FROM IN MEMORY SEARCH REQUEST
		if (prevFilter?.companies?.length) {
			for (const id of this.companyIds) {
				const found = prevFilter.companies.find((x) => x.id === id);
				if (found) { this.companies.push(found); }
			}
		} else if (Array.isArray(init.companies)) {
			this.companies = init.companies;
		}
	}

	/** Collapses the values in this search request object so they can be persisted to a query string */
	public collapse(): any {
		const response: { [k: string]: any } = super.collapse();
		if (this.companyIds && this.companyIds.length) { response.companyIds = this.companyIds.join(','); }
		if (this.deckIds && this.deckIds.length) { response.deckIds = this.deckIds.join(','); }
		if (this.deckVariationIds && this.deckVariationIds.length) { response.deckVariationIds = this.deckVariationIds.join(','); }
		return response;
	}

	/** Clears the values in this search request object */
	public clear() {
		super.clear();
		this.deckIds = [];
		this.deckVariationIds = [];
		this.companyIds = [];
	}

}
